const baseUrl = import.meta.env?.BASE_URL || '/';

export const IS_V2_TEST = baseUrl === '/teste/' || baseUrl.startsWith('/teste/');
export const RELEASE_CHANNEL = IS_V2_TEST ? 'v2-test' : 'production';

export function scopedStorageKey(key, isV2Test = IS_V2_TEST) {
  return isV2Test ? `${key}.v2-test` : key;
}
